import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed } from 'vue';
import Banner from '~/components/UIComponents/Banner.vue';
import { useSanityDocument } from '~/composables/useSanityDocument';
import SanityLink from '~/components/Sanity/serializers/SanityLink.vue';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketingBanner',
  props: {
    bannerRef: null
  },
  setup(__props: any) {

const props = __props as {
  bannerRef: string;
}



const { doc, isLoading } = useSanityDocument<
  ISanityDocuments[SanityDocumentSchema.MARKETING_BANNER]
>(
  computed(() => ({
    _id: props.bannerRef,
    _type: SanityDocumentSchema.MARKETING_BANNER,
  })),
);

const { $sanityImage } = useContext();
const logoImage = computed(() => {
  if (!doc.value?.logo?.asset) {
    return;
  }
  return $sanityImage.urlFor(doc.value?.logo).height(100).url();
});

const logoImageAlt = computed(() => {
  if (!doc.value?.logo?.alt) {
    return;
  }
  return doc.value?.logo?.alt;
});

const backgroundImageLarge = computed(() => {
  if (!doc.value?.landscapeBannerImage?.asset) {
    return;
  }
  return $sanityImage.urlFor(doc.value?.landscapeBannerImage).width(1920).url();
});

const backgroundImageSmall = computed(() => {
  if (!doc.value?.landscapeBannerImage?.asset) {
    return;
  }
  return $sanityImage.urlFor(doc.value?.landscapeBannerImage).width(1550).url();
});

return { __sfc: true,props, doc, isLoading, $sanityImage, logoImage, logoImageAlt, backgroundImageLarge, backgroundImageSmall, Banner, SanityLink }
}

})